// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA06BERjoj2Tq15mNY_qhHYjLLyW9OFSBI",
  authDomain: "webme-b47a1.firebaseapp.com",
  projectId: "webme-b47a1",
  storageBucket: "webme-b47a1.firebasestorage.app",
  messagingSenderId: "860331899439",
  appId: "1:860331899439:web:2111cc237b4a12ae3864da",
  measurementId: "G-ZHKMSFK1SR"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);